import React, { useState } from 'react';

const AddEducationModal = ({ isOpen, onClose, onEducationAdded }) => {
  const [formData, setFormData] = useState({
    institution: '',
    degree: '',
    fieldOfStudy: '',
    startDate: '',
    endDate: '',
    grade: '',
    location: '',
    description: ''
  });
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.institution.trim() || !formData.degree.trim()) {
      setError('Institution and degree are required');
      return;
    }
    setError('');
    onEducationAdded(formData);
    onClose();
    setFormData({
      institution: '',
      degree: '',
      fieldOfStudy: '',
      startDate: '',
      endDate: '',
      grade: '',
      location: '',
      description: ''
    });
  };

  const handleClose = () => {
    setError('');
    onClose();
    setFormData({
      institution: '',
      degree: '',
      fieldOfStudy: '',
      startDate: '',
      endDate: '',
      grade: '',
      location: '',
      description: ''
    });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add Education</h2>
          <button onClick={handleClose} className="modal-close">×</button>
        </div>
        <form onSubmit={handleSubmit} className="modal-body">
          {error && <div className="error-message">{error}</div>}
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Institution *</label>
              <input type="text" value={formData.institution} onChange={e => setFormData({...formData, institution: e.target.value})} className="input-field" required />
            </div>
            <div className="form-group">
              <label className="form-label">Degree *</label>
              <input type="text" value={formData.degree} onChange={e => setFormData({...formData, degree: e.target.value})} className="input-field" required />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Field of Study</label>
            <input type="text" value={formData.fieldOfStudy} onChange={e => setFormData({...formData, fieldOfStudy: e.target.value})} className="input-field" />
          </div>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Start Date</label>
              <input type="date" value={formData.startDate} onChange={e => setFormData({...formData, startDate: e.target.value})} className="input-field" />
            </div>
            <div className="form-group">
              <label className="form-label">End Date</label>
              <input type="date" value={formData.endDate} onChange={e => setFormData({...formData, endDate: e.target.value})} className="input-field" />
            </div>
          </div>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Grade/GPA</label>
              <input type="text" value={formData.grade} onChange={e => setFormData({...formData, grade: e.target.value})} className="input-field" />
            </div>
            <div className="form-group">
              <label className="form-label">Location</label>
              <input type="text" value={formData.location} onChange={e => setFormData({...formData, location: e.target.value})} className="input-field" />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Description</label>
            <textarea value={formData.description} onChange={e => setFormData({...formData, description: e.target.value})} rows={3} className="input-field textarea-field" />
          </div>
          <div className="modal-actions">
            <button type="button" onClick={handleClose} className="btn btn-secondary">Cancel</button>
            <button type="submit" className="btn btn-primary">Add Education</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEducationModal; 